import { mode } from '@chakra-ui/theme-tools';

// Color overrides for rc-tree, paired with the shape/layout rules in
// ./rcTree.css. Kept here (Chakra tokens, not hardcoded hex) so colors
// follow this app's palette (nexusTeal.100, graphite, ...) and react to
// dark mode automatically. Spread into styles.global in theme/index.js.
const rcTreeStyles = props => ({
  '.rc-tree .rc-tree-node-selected': {
    bg: mode('selected', 'whiteAlpha.200')(props),
  },
  '.rc-tree .rc-tree-treenode span.rc-tree-switcher': {
    color: mode('graphite.500', 'graphite.700')(props),
  },
  '.rc-tree.rc-tree-show-line .rc-tree-indent-unit::before, .rc-tree.rc-tree-show-line .rc-tree-indent-unit:last-child::after': {
    borderColor: mode('gray.300', 'graphite.700')(props),
  },
  '.rc-tree .rc-tree-treenode span.rc-tree-checkbox': {
    bg: mode('white.100', 'dark.100')(props),
    borderColor: mode('graphite.500', 'graphite.700')(props),
  },
  '.rc-tree .rc-tree-treenode span.rc-tree-checkbox-checked': {
    bg: 'nexusTeal.100',
    borderColor: 'nexusTeal.100',
  },
  '.rc-tree .rc-tree-treenode span.rc-tree-checkbox-checked::after': {
    borderColor: 'white.100',
  },
  '.rc-tree .rc-tree-treenode span.rc-tree-checkbox-indeterminate::after': {
    bg: 'nexusTeal.100',
  },
  '.rc-tree .rc-tree-treenode  .rc-tree-node-content-wrapper': {
    borderColor: mode('gray.300', 'graphite.700')(props),
    bg: mode('white.100', 'dark.100')(props),
  },
});

export default rcTreeStyles;
